var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28 35.6c-2-0.4-5.8-2.9-9.2-6.3s-5.8-7.2-6.2-9.3c-0.3-1.5 0.4-2.9 3.1-6.2l-6.9-11.7c-1.6 0.5-3.6 1.6-4.9 3.1-2 2.2-2.6 5-1.2 8.3 3.3 7.9 7 13.4 12.7 19.1 5.9 5.9 11.4 9.7 19.1 12.7 3.3 1.3 6.1 0.8 8.3-1.2 1.5-1.3 2.6-3.3 3.1-4.8l-11.6-6.8c-3.5 2.7-4.8 3.4-6.3 3.1zm0.3-1.9c0.8 0.2 2-0.6 5.3-3.2l0.5-0.4 13.9 8.2-0.1 0.7c-0.4 2-1.8 4.7-3.8 6.5-2.7 2.5-6.3 3.2-10.3 1.6-7.9-3.1-13.7-7-19.8-13.1-5.9-5.9-9.7-11.6-13.1-19.7-1.7-4.1-1-7.6 1.5-10.4 1.8-2 4.6-3.4 6.6-3.8l0.8-0.1 8.1 13.9-0.4 0.5c-2.6 3.2-3.2 4.4-3.1 5.2 0.3 1.7 2.6 5.2 5.7 8.4 3.2 3.1 6.7 5.4 8.2 5.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ccc1bb2a7301f0bfb40fd98a125d5653.svg";
export { ForwardRef as ReactComponent };